import React from 'react';
import DisabledWrapper from "@/components/DisabledWrapper";
import {r} from "@/utils/responsive";

interface ModalBlurShapesProps extends React.HTMLAttributes<HTMLDivElement> {
    shapeColor?: string;
}

const ModalBlurShapes: React.FC<ModalBlurShapesProps> = ({className, shapeColor = "#5282FF90", ...props}) => {
    return (
        <DisabledWrapper style={{
            zIndex: 2,
            mixBlendMode: 'plus-lighter',
            opacity: .9
        }}>
            <svg style={{
                width: r.vmax(1074),
                height: r.vmax(1151),
                position: 'absolute',
                top: r.vmax(186),
                right: r.vmax(-388),
                filter: `blur(${r.vmax(290)}`,
                opacity: .9,
            }} viewBox="0 0 1074 1151" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M7.96634e-05 911.243C9.1227e-05 1043.51 251 1150.74 924 1150.74C1212.02 1150.74 1008.03 199.599 937.908 87.442C726.908 -250.058 789.908 482.442 640.908 709.942C346.408 800.942 6.80998e-05 778.97 7.96634e-05 911.243Z"
                        fill={shapeColor}/>
                </g>
            </svg>
            <svg style={{
                width: r.vmax(1074),
                height: r.vmax(1151),
                position: 'absolute',
                top: r.vmax(158),
                right: r.vmax(-418),
                filter: `blur(${r.vmax(290)}`,
                opacity: .9,
            }} viewBox="0 0 1074 1151" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M7.96634e-05 911.243C9.1227e-05 1043.51 251 1150.74 924 1150.74C1212.02 1150.74 1008.03 199.599 937.908 87.442C726.908 -250.058 789.908 482.442 640.908 709.942C346.408 800.942 6.80998e-05 778.97 7.96634e-05 911.243Z"
                        fill={shapeColor}/>
                </g>
            </svg>
            <svg style={{
                width: r.vmax(1074),
                height: r.vmax(1151),
                position: 'absolute',
                top: r.vmax(186),
                left: r.vmax(-394),
                filter: `blur(${r.vmax(290)}`,
                opacity: .9,
            }} viewBox="0 0 1074 1151" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M1073.6 911.243C1073.6 1043.51 822.604 1150.74 149.604 1150.74C-138.412 1150.74 65.5775 199.599 135.697 87.442C346.696 -250.058 283.696 482.442 432.696 709.942C727.196 800.942 1073.6 778.97 1073.6 911.243Z"
                        fill={shapeColor}/>
                </g>
            </svg>
            <svg style={{
                width: r.vmax(1074),
                height: r.vmax(1151),
                position: 'absolute',
                top: r.vmax(158),
                left: r.vmax(-424),
                filter: `blur(${r.vmax(290)}`,
                opacity: .9,
            }} viewBox="0 0 1074 1151" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M1073.6 911.243C1073.6 1043.51 822.604 1150.74 149.604 1150.74C-138.412 1150.74 65.5775 199.599 135.697 87.442C346.696 -250.058 283.696 482.442 432.696 709.942C727.196 800.942 1073.6 778.97 1073.6 911.243Z"
                        fill={shapeColor}/>
                </g>
            </svg>
        </DisabledWrapper>
    );
};

export default ModalBlurShapes;
